export default __webpack_public_path__ + "static/media/billy-chating.305b7e2f.png";